import styled from 'styled-components'

interface ButtonProps {
	height?: string
	width?: string
}

export const ButtonWrapper = styled.button<ButtonProps>`
	position: relative;
	cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
	font-size: var(--fs-sm, 16px);
	font-weight: var(--fw-md, 500);
	font-family: var(--font-bold);
	border-radius: 50px;
	width: ${(props) => (props.width ? props.width : `var(--btn-width, 100%)`)};
	height: ${(props) => (props.height ? props.height : `var(--btn-height)`)};
	background-color: ${(props) =>
		props.disabled
			? 'var(--btn-bg-disabled)'
			: 'var(--btn-bg-color, #0284ff)'};
	border: ${(props) =>
		props.disabled
			? '1px solid var(--btn-bg-disabled)'
			: '1px solid var(--btn-bg-color, #0284ff)'};
	color: ${(props) =>
		props.disabled ? 'var(--btn-text-disabled)' : 'var(--btn-text-color)'};

	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
`
